module.exports = __webpack_public_path__ + "static/media/MPratings.84da1e2c.png";